<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.chemicalSurfaceTreatmentList && this.segment.chemicalSurfaceTreatmentList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.chemical.surface.treatment</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block-coating-surface sextuple-column">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.type</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.coating.surface.face</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.element1</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.avg1</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.element2</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.avg2</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.element3</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.avg3</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.element4</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.avg4</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.element5</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.chemical.surface.chemical.treatment.avg5</div>
					</div>
				</div>
				<div class="card-contents-infos" *ngFor="let organicCoating of segment.organicCoatingList">
					<div class="card-content-info">
						<div class="card-content-value">{{ organicCoating.organicCoatingType ? organicCoating.organicCoatingType : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos" *ngFor="let chemicalSurfaceTreatment of segment.chemicalSurfaceTreatmentList">
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.face ? chemicalSurfaceTreatment.face : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.element1 ? chemicalSurfaceTreatment.element1 : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.averageValue1 ? (chemicalSurfaceTreatment.averageValue1 | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.element2 ? chemicalSurfaceTreatment.element2 : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.averageValue2 ? (chemicalSurfaceTreatment.averageValue2 | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.element3 ? chemicalSurfaceTreatment.element3 : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.averageValue3 ? (chemicalSurfaceTreatment.averageValue3 | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.element4 ? chemicalSurfaceTreatment.element4 : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.averageValue4 ? (chemicalSurfaceTreatment.averageValue4 | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.element5 ? chemicalSurfaceTreatment.element5 : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-value">{{ chemicalSurfaceTreatment.averageValue5 ? (chemicalSurfaceTreatment.averageValue5 | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
<ng-template #underscore>
	<div class="card-content-value">{{ UNDERSCORE }}</div>
</ng-template>